import React, { useState } from "react";
import { Share2, Link2, Check } from "lucide-react";
import { toast } from "sonner";

const NETS = [
  { id: "whatsapp", label: "WhatsApp", cls: "bg-[#25D366]", href: (u, m) => `https://wa.me/?text=${encodeURIComponent(`${m} ${u}`)}` },
  { id: "facebook", label: "Facebook", cls: "bg-[#1877F2]", href: (u) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}` },
  { id: "x", label: "X", cls: "bg-black", href: (u, m) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(m)}&url=${encodeURIComponent(u)}` },
  { id: "linkedin", label: "LinkedIn", cls: "bg-[#0A66C2]", href: (u) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(u)}` },
];

export const ShareButtons = ({ message, t }) => {
  const [copied, setCopied] = useState(false);
  const url = window.location.href.split("?")[0];

  const nativeShare = async () => {
    try { await navigator.share({ title: document.title, text: message, url }); } catch (e) { /* cancelled */ }
  };
  const copy = async () => {
    await navigator.clipboard.writeText(`${message} ${url}`);
    setCopied(true); toast.success(t("share.copied")); setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="condition-share-buttons">
      <span className="flex items-center gap-1 text-sm font-semibold text-gray-700"><Share2 size={15} /> {t("share.title")}</span>
      {navigator.share && (
        <button onClick={nativeShare} data-testid="share-native-button" className="rounded-full bg-emerald-500 px-3 py-1.5 text-xs font-bold text-white hover:bg-emerald-600 sm:hidden">{t("share.title")}</button>
      )}
      {NETS.map((n) => (
        <a key={n.id} href={n.href(url, message)} target="_blank" rel="noreferrer" data-testid={`share-${n.id}-button`}
          className={`rounded-full px-3 py-1.5 text-xs font-bold text-white transition-opacity hover:opacity-85 ${n.cls}`}>{n.label}</a>
      ))}
      <button onClick={copy} data-testid="share-copy-button" className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs font-bold text-gray-700 hover:bg-gray-50">
        {copied ? <Check size={13} /> : <Link2 size={13} />} {t("share.copy")}
      </button>
    </div>
  );
};
